import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCfe: [],
		cfe: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		getCfeModel(state) {
			let cfe = { ...state.cfe }
			cfe.cfenasc = Utils.ParseToDate(cfe.cfenasc)
			cfe.cferamal = Utils.ParseToString(cfe.cferamal)
			return cfe
		}
	},
	mutations: {
		set(state, cfe) {
			state.cfe = cfe
			state.cfe.cfenasc = new Date(cfe.cfenasc).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit' })
			if (cfe) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cfe = null
		},
		setParamsDataTable(state, payload) {
			state.lstCfe = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, { cfecliente, cfenome }) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Customer/Contact/Find?cfecliente=${cfecliente}&cfenome=${cfenome}`)
				.then(response => {
					let cfe = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cfe)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			store.state.cfe.cfeobserv = Utils.ParseToString(store.state.cfe.cfeobserv)
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Customer/Contact/Insert", store.getters.getCfeModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push(`/oryxpdv/contatos/${store.state.cfe.cfecliente}`)
					store.state.cfe = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)

			await this._vm.$axios
				.put("/Customer/Contact/Update", store.getters.getCfeModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push(`/oryxpdv/contatos/${store.state.cfe.cfecliente}`)
					store.state.cfe = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},

		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.delete(`/Customer/Contact/Delete?cfecliente=${store.state.cfe.cfecliente}&cfenome=${store.state.cfe.cfenome}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/contatos/" + store.state.cfe.cfecliente)
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Customer/Contact/FindList")
				.then(response => {
					let lstCfe = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCfe = lstCfe
					store.state.hasNext = lstCfe.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCfe = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/Contact/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCfe = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		},
		async findEmailDocFis(store, cpfCnpj) {
			return await store.dispatch("findEmailCfeByType", { route: "/Customer/Contact/FindEmailDocFis/", cpfCnpj })
		},
		async findEmailDocFin(store, cpfCnpj) {
			return await store.dispatch("findEmailCfeByType", { route: "/Customer/Contact/FindEmailDocFin/", cpfCnpj })
		},
		async findEmailMarket(store, cpfCnpj) {
			return await store.dispatch("findEmailCfeByType", { route: "/Customer/Contact/FindEmailMarket/", cpfCnpj })
		},
		async findEmailCfeByType(store, { cpfCnpj, route }) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Buscando contatos do cliente", indeterminate: true },
				{ root: true }
			)
			let customerMail = await this._vm.$axios
				.get(`${route}${cpfCnpj}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return null
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return customerMail
		}
	}
}
